module.exports = __webpack_public_path__ + "static/scale-model-of-worcester-massachusetts-b70055d4461f3b8e7acc5fe11372d847.png";